<template>
<div class="headerWrap">
    <span @click="back"><img style="width:9px" src="../assets/images/left-arrow.png" alt=""></span>
    <p>{{title}}</p>
</div>
</template>

<script>

export default {
components: {},

computed: {
    title(){
        return this.$route.meta.title
    }
},
watch: {},
methods: {
    back(){
        this.$router.go(-1)
    }
},
created() {
},
mounted() {

},
}
</script>
<style scoped lang="less">
.headerWrap{
    height: 50px;
    line-height: 50px;
    background:#87E2CD;
    color: #fff;
    position: relative;
    text-align: center;
    span{
        position: absolute;
        left: 10px;
        font-size: 20px;
    }
}
</style>